"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGeneratedCashToBorrowingBaseDependenciesForDetach = exports.addCashBalancesFeedContextArtifacts = exports.createCashBalancesFeedContext = void 0;
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const createCashBalancesFeedContext = (manualBankAccountReport) => {
    (0, common_1.finleyAssert)(manualBankAccountReport.creditFacilitySlug, 'creditFacilitySlug of manualBankAccountReport type must be defined');
    return {
        id: (0, uuid_1.v4)(),
        type: 'cashBalancesFeedContext',
        configuration: {},
        loanProductSlug: null,
        creditFacilitySlug: manualBankAccountReport.creditFacilitySlug,
        artifactDocumentId: manualBankAccountReport.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `cashBalancesFeedContext_${manualBankAccountReport.creditFacilitySlug}`, // uniq for cashBalancesFeedContext
    };
};
exports.createCashBalancesFeedContext = createCashBalancesFeedContext;
const addCashBalancesFeedContextArtifacts = (graph) => {
    const dataTapeDependencies = (0, lodash_1.cloneDeep)(graph.dataTapeDependencies);
    const dataTapes = (0, lodash_1.cloneDeep)(graph.dataTapes);
    const manualBankAccountReports = utils.filterManualBankAccountReports({
        dataTapes,
    });
    const borrowingBaseReports = utils.filterBorrowingBaseReports({ dataTapes });
    const directInsertBorrowingBaseReports = utils.filterDirectInsertBorrowingBaseReports({ dataTapes });
    const borrowingBaseReportIds = [];
    borrowingBaseReports.forEach(({ id }) => borrowingBaseReportIds.push(id));
    directInsertBorrowingBaseReports.forEach(({ id }) => borrowingBaseReportIds.push(id));
    manualBankAccountReports.forEach((manualBankAccountReport) => {
        const cashBalancesFeedContext = (0, exports.createCashBalancesFeedContext)(manualBankAccountReport);
        // remove edge from ManualBankAccountReport => BorrowingBaseReport
        const removedDependencies = (0, lodash_1.remove)(dataTapeDependencies, (dep) => borrowingBaseReportIds.includes(dep.outputArtifactId) &&
            dep.inputArtifactId === manualBankAccountReport.id);
        (0, common_1.finleyAssert)(removedDependencies.length === 1, 'manualBankAccountReport should be associated with only 1 borrowing base report');
        const { outputDependency } = utils.insertDependency({
            dataTapeDependency: removedDependencies[0],
            insertId: cashBalancesFeedContext.id,
        });
        // we don't want to add inputDependency here (manualBankAccountReport => cashBalancesFeedContext)
        // as bank report lambda will create leaf node cashBalanceFeed once all required
        // cash balances have been uploaded.
        dataTapeDependencies.push(outputDependency);
        dataTapes.push(cashBalancesFeedContext);
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addCashBalancesFeedContextArtifacts = addCashBalancesFeedContextArtifacts;
/**
 * Unfortunately our synthetic detach process is a bit tangled with legacy
 * logic that removes nodes and re-adjusts dependencies in single passes,
 * rather than distinct individual steps.
 * Ideally this can manage the full "detach" process, but for now, this carries
 * over prior logic that just manages creating the original dependencies that
 * we want to re-setup during detach process for UI purposes.
 */
const createGeneratedCashToBorrowingBaseDependenciesForDetach = (params) => {
    const { dataTapes } = params;
    // Fetch "generatedCashBalanceFeeds" as these are the target artifacts
    const generatedCashBalanceFeeds = utils.filterGeneratedCashBalanceFeeds({
        dataTapes,
    });
    // Fetch "borrowingBaseReports" (and direct) as these are potential outputs
    const borrowingBaseReports = utils.filterBorrowingBaseReports({ dataTapes });
    const directInsertBorrowingBaseReports = utils.filterDirectInsertBorrowingBaseReports({ dataTapes });
    return generatedCashBalanceFeeds.map((generatedCashBalanceFeed) => {
        const { creditFacilitySlug, artifactSlug } = generatedCashBalanceFeed;
        (0, common_1.finleyAssert)(creditFacilitySlug, `creditFacilitySlug must exist on generatedCashBalanceFeed [artifactSlug:${artifactSlug}]`);
        // First check if the generated cash balance feed was referenced by a
        // "directInsertBorrowingBaseReport" node. If so, then prioritize re-linking
        // the cash balance feed node to this.
        const targetDirectInsertBorrowingBaseReport = directInsertBorrowingBaseReports.find((node) => node.creditFacilitySlug === creditFacilitySlug &&
            node.configuration.generatedCashBalanceFeedArtifactSlug ===
                artifactSlug);
        if (targetDirectInsertBorrowingBaseReport) {
            return {
                outputArtifactId: targetDirectInsertBorrowingBaseReport.id,
                inputArtifactId: generatedCashBalanceFeed.id,
            };
        }
        // If no "directInsertBorrowingBaseReport" is pointing to this, then default
        // back to assuming single borrowing base report for credit facility.
        const filteredBorrowingBaseReports = borrowingBaseReports.filter((report) => report.creditFacilitySlug === creditFacilitySlug);
        (0, common_1.finleyAssert)(filteredBorrowingBaseReports.length === 1, `unable to find single borrowing base report with creditFacilitySlug ${creditFacilitySlug}`);
        const borrowingBaseReport = filteredBorrowingBaseReports[0];
        return {
            outputArtifactId: borrowingBaseReport.id,
            inputArtifactId: generatedCashBalanceFeed.id,
        };
    });
};
exports.createGeneratedCashToBorrowingBaseDependenciesForDetach = createGeneratedCashToBorrowingBaseDependenciesForDetach;
//# sourceMappingURL=cashBalancesFeedContext.js.map